import React, { useContext } from 'react';
import style from './style.module.less';
import messages from './messages';
import { Input } from 'ui-components/components/input';
import { FilterEditorContext } from '../../context';
import { FormattedMessage } from 'react-intl';

const fieldId = `nameId-${messages.allocationRuleFiltersetEditorEntryLabel.id}`;
const FilterName = () => {
  const { filterName, setFilterName } = useContext(FilterEditorContext);

  return (
    <div className={style.wrapper}>
      <FormattedMessage {...messages.allocationRuleFiltersetEditorHeader} />
      <div className={style['entry-wrapper']}>
        <FormattedMessage {...messages.allocationRuleFiltersetEditorEntryLabel} />
        <Input aria-labelledby={fieldId} className={style.input} onChange={setFilterName} value={filterName} />
      </div>
      <FormattedMessage
        {...messages.allocationRuleFiltersetEditorSupplemental}
        values={{
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
    </div>
  );
};

export default FilterName;
